import React from 'react';
import classes from './AdditionalTopBar.module.css';
import styles from './Topbar.module.css';
import Logo from "../../assets/logo1.png";
import svg from '../../assets/svg';
import { useNavigate } from 'react-router-dom';


function AdditionalTopBar({setOpenTobBar}) {
    const navigate = useNavigate();

    // Used only by the links commented out below.
    // eslint-disable-next-line no-unused-vars
    const handleActive = (section) => {
        //  If user is not on homepage, go to homepage before scrolling
        navigate(`/#${section}`);
        if (window.location.pathname !== "/") {
            setTimeout(() => {
                const element = document.getElementById(section);
                if (element) element.scrollIntoView({ behavior: "smooth" });
            }, 300);
        } else {
            const element = document.getElementById(section);
            if (element) element.scrollIntoView({ behavior: "smooth" });
        }
    };

  return (
    <header className={classes.additionalTopBar}>
        <div className={styles.left}>
        <img src={Logo} alt="Logo" className={styles.logoImage} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "8px",
            gap: "4px",
          }}
        >
          <div className={`${styles.logo} ${classes.logo}`}>Jose Charles Martin</div>
          <div className={`${styles.logo1} ${classes.logo1}`}>Visionary Leader</div>
        </div>
      </div>

        {/* Events and News are parked with their landing sections in App.js,
            and Gallery has moved into the main header, so this bar has no
            links of its own at the moment. */}
        <div className={classes.navigations}>
            {/* <p onClick={() => handleActive("events")}>Events</p>
            <p onClick={() => handleActive("news")}>News</p>
            <p onClick={() => handleActive("gallery")}>Gallery</p> */}
        </div>

      <span onClick={setOpenTobBar}>
          {svg.cancelIcon}
      </span>
    </header>
  )
}

export default AdditionalTopBar